import { Injectable } from '@angular/core';
import { L10nLocale, L10nTranslationService } from 'angular-l10n';

@Injectable()
export class TranslationHelperService {

  constructor(
    public translationService: L10nTranslationService
  ) { }

  getLocalizedValue(obj: any, propName: string = 'names', language?: string): any {
    if (obj && Array.isArray(obj[propName])) {
      if (!language) {
        language = this.getCurrentLanguage();
      }
      const name = obj[propName].find(item => item.language && item.language.toString() === language);
      if (name) {
        return name.value;
      }
    }
    return null;
  }

  getLocalizedValueFromListById(id: string, list: any[]): any {
    if (Array.isArray(list)) {
      const item = list.find(item => item.id === id);
      if (item) {
        const value = this.getLocalizedValue(item);
        if (value) {
          return value;
        }
      }
    }
    return null;
  }

  getCurrentLanguage(): string {
    const currentLocale = this.translationService.getLocale();
    return currentLocale.language;
  }

  getCurrentLocale(): L10nLocale {
    return this.translationService.getLocale();
  }

  translate(keys: string | string[], args?: any, lang?: string): string | any {
    if (lang) {
      return this.translationService.translate(keys, args);
    }
    return this.translationService.translate(keys, args);
  }
  
  setLocale(locale: L10nLocale): void {
    this.translationService.setLocale(locale);
  }
}
